const { locale } = Intl.DateTimeFormat().resolvedOptions();

export { locale };
